import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // If using React Router

const useScrollToHash = () => {
  const location = useLocation(); // Or window.location if not using React Router

  useEffect(() => {
    const { hash } = location;
    if (hash) {
      const id = hash.substring(1);
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100); // Small delay to ensure element is rendered
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 500); 
      }
    }
  }, [location.hash]);
};

export default useScrollToHash;